import { TrafficLightIcon } from './TrafficLightIcon';

/**
 * author: Google
 * id 073B4489-5787-432C-9D10-50B270182D34
 * name traffic-light
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/traffic-light.svg
 * tags
 * - Transportation + Road 
 */
export const StopLightIcon = TrafficLightIcon;
export default StopLightIcon